import { defineMessages } from 'react-intl';

const messages = defineMessages({
  monthlyTotal: {
    description: 'Monthly Total line item description',
    defaultMessage: 'Monthly total',
    id: '90vZXS',
  },
  yearlyTotal: {
    description: 'Yearly Total line item description',
    defaultMessage: 'Yearly total',
    id: 'lJ6B+A',
  },
  usersLineItem: {
    description: 'Subscription line items user count label',
    defaultMessage: 'Users ({count})',
    id: 'TKVZAp',
  },
  yourCarriersLineItem: {
    description: 'Subscription line items your carriers label',
    defaultMessage: 'Your Carriers',
    id: 'r7g1s6',
  },
  yourCarriersLineItemDonwgrade: {
    description: 'Subscription line items your carriers label with pending downgrade',
    defaultMessage: 'Your Carriers (Deactivates on {date})',
    id: '9TEC/k',
  },
  countIncluded: {
    description: 'Number of users automatically included in plan',
    defaultMessage: '{count} included',
    id: 'aZB2n8',
  },
  usersIncludedLabel: {
    description: 'Label for number of users automatically included in plan',
    defaultMessage: 'Users:',
    id: 'WP1uxP',
  },
  newSubscriptionCardHeader: {
    description: 'Subscription card header',
    defaultMessage: 'Plan Details',
    id: 'go3FWR',
  },
  subscriptionHeader: {
    description: 'Subscription card header',
    defaultMessage: 'Subscription',
    id: 's5rdyG',
  },
  appliedCouponExplainerGeneric: {
    description: 'a message that informs the user that a coupon has been applied to their subscription cost.',
    defaultMessage: 'A coupon code has been applied to your subscription.',
    id: 'gq9Dt3',
  },
  monthlyPrice: {
    description: 'updated monthly subscription amount',
    defaultMessage: ' {amount} {currency}/ mo',
    id: '+0DpUV',
  },
  updatedPlanName: {
    description: 'updated subscription page plan name',
    defaultMessage: 'Plan:',
    id: 'YGoE0f',
  },
  freeTrialText: {
    description: 'text for subscription card free trial plan name',
    defaultMessage: 'Free Trial',
    id: '6y/SLL',
  },
  expired: {
    description: 'Expired wording on subscription card',
    defaultMessage: 'Expired',
    id: 'Egqgsg',
  },
  cancelled: {
    description: 'Cancelled wording on subscription card',
    defaultMessage: 'Cancelled',
    id: 'S9GoSq',
  },
  updatedSellingChannelLimit: {
    description: 'updated subscription selling channel limit',
    defaultMessage: 'Selling Channels:',
    id: 'qE2r3E',
  },
  unlimited: {
    description: 'subscription unlimited',
    defaultMessage: 'Unlimited',
    id: 'hjlgkE',
  },
  updatedShipmentsPerMonth: {
    description: 'updated subscription shipment limit',
    defaultMessage: 'Shipments / mo:',
    id: 'mPAmLm',
  },
  updatedUserLimit: {
    description: 'updated subcription user limit',
    defaultMessage: 'User Accounts:',
    id: 'fqI/FQ',
  },
  ctpBillingLinkPaymentsAndSubscriptionPage: {
    description: 'change billing info for CTP plans message',
    defaultMessage: 'Your subscription is managed via <supportLink>ShipStation Support</supportLink> or your UPS Account Manager.',
    id: 'A/RQyX',
  },
  ctpCancellationNoticePaymentsAndSubscriptionPage: {
    description: 'subscription restart prompt for CTP program users',
    defaultMessage:
      'Subscription expired on {endDate}. To reactivate, <supportLink>contact support</supportLink> or your UPS Account Manager.',
    id: 'GeEj8y',
  },
  undoCtpCancellation: {
    description: 'button text for users to undo cancellation of their subscription',
    defaultMessage: 'Reactivate (paid until {endDate})',
    id: '7xtssW',
  },
  pastInvoices: {
    description: 'Link to past invoices',
    defaultMessage: '<a>Past Invoices</a>',
    id: 'oT2yZh',
  },
  undoCancellation: {
    description: 'Undo cancellation link for users who have cancelled their accounts',
    defaultMessage: 'Undo Cancellation',
    id: '7YhecG',
  },
  manageUsers: {
    description: 'Manage user accounts link in add ons modal',
    defaultMessage: 'Manage users',
    id: 'islk3x',
  },
  addUsers: {
    description: 'add users from subscription card',
    defaultMessage: 'Add users',
    id: 'n+FyZq',
  },
  manageAddOnsButton: {
    description: 'Manage your Add Ons Button text',
    defaultMessage: 'Add-Ons',
    id: 'iF2y3M',
  },
  included: {
    description: 'Informs user that the add-on cost is paid for by the subscription plan',
    defaultMessage: 'Included',
    id: 'YKkdTP',
  },
  features: {
    description: 'section title for Features',
    defaultMessage: 'Features',
    id: 'BUQJfu',
  },
  yourCarriers: {
    description: 'section title for sellers who are using their own carriers',
    defaultMessage: 'Your Carriers',
    id: 'C58YFr',
  },
  addOnsAndFeatures: {
    description: 'section title for Add-Ons and Features',
    defaultMessage: 'Add-Ons and Features',
    id: 'Ywo5Nh',
  },
  includedWithAsterisk: {
    description: 'Informs user that the add-on cost is paid for by the subscription plan',
    defaultMessage: 'Included*',
    id: 'xbDwnf',
  },
  additionalUsers: {
    description: 'label to display for the number of Additional Users that the seller will have to pay for with their selected plan',
    defaultMessage: 'Additional Users:',
    id: 'ueJEKM',
  },
  includedUsers: {
    description: 'label to display for the number of Included Users that come with the sellers selected plan',
    defaultMessage: 'Included Users:',
    id: 'mgiuaM',
  },
  users: {
    description: 'section title for the "Users" section fo the Plan Details card',
    defaultMessage: 'Users',
    id: '0ihEQs',
  },
  analyticsLicenses: {
    description: 'Header for analytics licenses section in subscription card',
    defaultMessage: 'Analytics Licenses',
    id: 'EYUkxa',
  },
  includedAnalyticsLicenses: {
    description: 'Label for included analytics licenses',
    defaultMessage: 'Included Licenses:',
    id: '+otvrE',
  },
  additionalAnalyticsLicenses: {
    description: 'Label for additional analytics licenses with count',
    defaultMessage: 'Additional Licenses:',
    id: 'AuruHi',
  },
  additionalFeeForBYOA: {
    defaultMessage: '*{fee} fee per label when using Your Carrier accounts.',
    id: 'sr4lTM',
    description: 'footnote displayed in the Plan Details section if the seller is in a plan that charges to "Bring Your Own Carriers"',
  },
  trial: {
    description: 'text presented beside the line item label if the line item represents a feature that is being trialed',
    defaultMessage: '(Trial)',
    id: 'C2oGQC',
  },
  deactivationDate: {
    description: 'the date the add-on will deactivate',
    defaultMessage: 'Deactivates on {deactivationDt}',
    id: '4dJg/G',
  },
  noPlan: {
    description: 'Plan name shown for free accounts with 0 shipment limit',
    defaultMessage: 'No Plan Selected',
    id: 'COlbgp',
  },
});

export default messages;
